"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
/* Layouts */
var LETTERS_LAYOUT = [["A", "Z", "E", "R", "T", "Y", "U", "I", "O", "P"], ["Q", "S", "D", "F", "G", "H", "J", "K", "L", "M"], ["Shift", "W", "X", "C", "V", "B", "N", "←"], ["123", ".", "@", "Space", "Return"]];
var NUMBERS_LAYOUT = [["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], ["-", "_", "!", "?", ":", ";", "/", "&", "%"], ["Shift", "←"], ["ABC", "Space", "Return"]];

/* 🔘 Touche tactile optimisée */
var KeyButton = /*#__PURE__*/_react.default.memo(function KeyButton(_ref) {
  var label = _ref.label,
    onPress = _ref.onPress,
    minWidth = _ref.minWidth,
    font = _ref.font;
  var _ref2 = (0, _react.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    pressed = _ref3[0],
    setPressed = _ref3[1];
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onPointerDown: function onPointerDown() {
      return setPressed(true);
    },
    onPointerUp: function onPointerUp() {
      setPressed(false);
      onPress(label);
    },
    onPointerCancel: function onPointerCancel() {
      return setPressed(false);
    },
    onPointerLeave: function onPointerLeave() {
      return setPressed(false);
    },
    style: {
      minWidth: minWidth,
      padding: "1em",
      fontSize: "1.2em",
      borderRadius: "0.4em",
      background: "#0000004D",
      color: "#fff",
      border: "2px solid white",
      fontWeight: "bold",
      fontFamily: font || "Arial",
      /* UX tactile */
      userSelect: "none",
      touchAction: "manipulation",
      /* ✨ Feedback visuel */
      transform: pressed ? "scale(0.92)" : "scale(1)",
      opacity: pressed ? 0.85 : 1,
      boxShadow: pressed ? "inset 0 0.25em 0.45em rgba(0,0,0,0.45)" : "0 0.15em 0.3em rgba(0,0,0,0.35)",
      transition: "transform 60ms ease, opacity 60ms ease, box-shadow 60ms ease"
    }
  }, label);
});
function AzertyMailing(_ref4) {
  var input = _ref4.input,
    setInput = _ref4.setInput,
    project = _ref4.project,
    setVisible = _ref4.setVisible,
    anchorRef = _ref4.anchorRef;
  var keyboardRef = (0, _react.useRef)(null);
  var dragStartRef = (0, _react.useRef)({
    x: 0,
    y: 0
  });
  var _ref5 = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    position = _ref6[0],
    setPosition = _ref6[1];
  var _ref7 = (0, _react.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    dragging = _ref8[0],
    setDragging = _ref8[1];
  var _ref9 = (0, _react.useState)("letters"),
    _ref0 = _slicedToArray(_ref9, 2),
    layout = _ref0[0],
    setLayout = _ref0[1];
  var _ref1 = (0, _react.useState)(1.1),
    _ref10 = _slicedToArray(_ref1, 2),
    scale = _ref10[0],
    setScale = _ref10[1];
  var _ref11 = (0, _react.useState)(false),
    _ref12 = _slicedToArray(_ref11, 2),
    isReady = _ref12[0],
    setIsReady = _ref12[1];

  /* 📐 Scale dynamique */
  var computeScale = (0, _react.useCallback)(function (w) {
    return w >= 1200 ? 1.1 : 0.9;
  }, []);
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      var newScale = computeScale(window.innerWidth);
      setScale(function (s) {
        return s === newScale ? s : newScale;
      });
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [computeScale]);

  /* 📍 Position initiale */
  (0, _react.useLayoutEffect)(function () {
    if (!(anchorRef !== null && anchorRef !== void 0 && anchorRef.current) || !keyboardRef.current) return;
    var newScale = computeScale(window.innerWidth);
    setScale(newScale);
    var rect = anchorRef.current.getBoundingClientRect();
    var keyboardWidth = keyboardRef.current.offsetWidth * newScale;
    setPosition({
      x: rect.left + rect.width / 2 - keyboardWidth / 2,
      y: rect.bottom - 600
    });
    setIsReady(true);
  }, [anchorRef, computeScale]);

  /* 🖐 Drag tactile */
  var startDrag = (0, _react.useCallback)(function (x, y) {
    setDragging(true);
    dragStartRef.current = {
      x: x - position.x,
      y: y - position.y
    };
  }, [position]);
  var moveDrag = (0, _react.useCallback)(function (x, y) {
    if (!dragging) return;
    setPosition({
      x: x - dragStartRef.current.x,
      y: y - dragStartRef.current.y
    });
  }, [dragging]);
  var stopDrag = (0, _react.useCallback)(function () {
    return setDragging(false);
  }, []);

  /* ⌨️ Gestion des touches */
  var handleKeyClick = (0, _react.useCallback)(function (key) {
    if (key === "←") setInput(function (v) {
      return v.slice(0, -1);
    });else if (key === "Space") setInput(function (v) {
      return v + " ";
    });else if (key === "Return") setInput(function (v) {
      return v + "\n";
    });else if (key === "123") setLayout("numbers");else if (key === "ABC") setLayout("letters");else if (key !== "Shift") setInput(function (v) {
      return v + key;
    });
  }, [setInput]);
  var currentLayout = (0, _react.useMemo)(function () {
    return layout === "letters" ? LETTERS_LAYOUT : NUMBERS_LAYOUT;
  }, [layout]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: keyboardRef,
    style: {
      position: "absolute",
      top: position.y,
      left: position.x,
      zIndex: 14000,
      padding: "0.6em",
      background: "rgba(255,255,255,0.92)",
      borderRadius: "1em",
      boxShadow: "0 0.6em 1.2em rgba(0,0,0,0.3)",
      backdropFilter: "blur(6px)",
      transform: "scale(".concat(scale, ")"),
      transformOrigin: "top left",
      width: "fit-content",
      visibility: isReady ? "visible" : "hidden"
    },
    onPointerMove: function onPointerMove(e) {
      return dragging && moveDrag(e.clientX, e.clientY);
    },
    onPointerUp: stopDrag,
    onPointerCancel: stopDrag
  }, /*#__PURE__*/_react.default.createElement("button", {
    onPointerUp: function onPointerUp() {
      return setVisible(false);
    },
    type: "button",
    style: {
      position: "absolute",
      top: -35,
      left: "95%",
      width: "2.2em",
      height: "2.2em",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.95)",
      boxShadow: "0 0.3em 0.6em rgba(0,0,0,0.35)",
      fontSize: "1.3em",
      cursor: "pointer"
    }
  }, "\u2715"), currentLayout.map(function (row, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      style: {
        display: "flex",
        gap: "0.3em",
        marginBottom: "0.3em"
      }
    }, row.map(function (key) {
      var minWidth = "3em";
      if (["Shift", "Return", "←"].includes(key)) minWidth = "6em";
      if (key === "Space") minWidth = "15em";
      return /*#__PURE__*/_react.default.createElement(KeyButton, {
        key: key,
        label: key,
        onPress: handleKeyClick,
        minWidth: minWidth,
        font: project === null || project === void 0 ? void 0 : project.default_button_font
      });
    }));
  }));
}
var _default = exports.default = AzertyMailing;